import React from 'react';
import { AnswersApi, Category, createAnswersApi } from '@wix/answers-api';
import { ANSWERS_API_BASE_URL } from '../constants';
import { createHttpService } from '../utils/answers';
import { PageTemplateData } from '../components/PageTemplate';
import { noop } from '../utils/noop';

export const answersApi = createAnswersApi({
  baseUrl: ANSWERS_API_BASE_URL,
  http: createHttpService(),
  clientName: 'helpcenter',
});

type ContextType = {
  pageTemplateData: PageTemplateData;
  setPageTemplateData: (pageTemplateData: PageTemplateData) => void;
  answersApi: AnswersApi;
  categoriesTree: Category[];
  isMobile: boolean;
  isTablet: boolean;
  experiments: { scopes: string[] };
};

export const Context = React.createContext<ContextType>({
  answersApi,
  categoriesTree: [],
  pageTemplateData: {},
  setPageTemplateData: noop,
  isMobile: false,
  isTablet: false,
  experiments: { scopes: [] },
});
